export const actionTypes = {
  REQUEST_ORDER_BONUS: 'REQUEST_ORDER_BONUS',
  SUCCESS_ORDER_BONUS: 'SUCCESS_ORDER_BONUS',
  ERROR_ORDER_BONUS: 'ERROR_ORDER_BONUS'
}